import { outfitMeta, outfitPieces, outfitStatus, type Item, type Outfit } from '@closetly/core';
import { navigate } from '../lib/router';
import { Collage } from './Collage';

/** An outfit on the board, Pinterest style: the collage with its name underneath. */
export function OutfitPin({ outfit, items, currency }: { outfit: Outfit; items: Item[]; currency: string }) {
  const pieces = outfitPieces(outfit, items);
  const status = outfitStatus(pieces);
  const href = `/outfits/${outfit.id}`;

  return (
    <a
      className={`pin${status.complete ? ' complete' : ''}`}
      href={href}
      onClick={(e) => {
        e.preventDefault();
        navigate(href);
      }}
    >
      <Collage pieces={pieces} />
      <span className="pin-meta">
        <strong>{outfit.name || 'Outfit ohne Namen'}</strong>
        <span>{outfitMeta(status, currency)}</span>
      </span>
    </a>
  );
}
